import { getAllSpecializationAreasReq } from "../../../../../redux/guest-slices/common.slice"
import SpecializationAreas from "../../../../../components/ui/SpecializationAreas"
import InputField1 from "../../../../../components/ui/InputField1"
import { Grid2 as Grid, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { Fragment, useEffect, useState } from "react"

function ArtTherapist({ errors, onChangFun }) {
  const dispatch = useDispatch()
  const [areas, setAreas] = useState([])
  const { specialist } = useSelector(state => state.specialistSlice)

  const handleGetAreas = (filters) => {
    dispatch(getAllSpecializationAreasReq({
      limit: filters?.limit || 10,
      id: "67d90056c2c4d5ab747f8b3e"
    })
    ).unwrap().then((data) => {
      setAreas(data)
    }).catch(() => { })
  }

  useEffect(() => {
    handleGetAreas()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="trainingBackground"
          label="Training in Art Therapy *"
          placeholder="Enter Training in Art Therapy"
          errText="Please enter training in art therapy"
          defaultValue={specialist?.profile?.trainingBackground || ""}
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="qualification"
          label="Qualification in Art Therapy *"
          placeholder="Enter Qualification in Art Therapy"
          errText="Please enter qualification in art therapy"
          defaultValue={specialist?.profile?.qualification || ""}
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="textarea"
          errors={errors}
          name="artTherapyTechniques"
          label="Art Therapy Techniques *"
          errText="Please enter art therapy techniques"
          placeholder="List the art therapy techniques you use, such as drawing, painting, sculpting, etc"
          defaultValue={specialist?.profile?.artTherapyTechniques || ""}
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="textarea"
          errors={errors}
          label="Specialization Areas *"
          name="specializationAreaDescription"
          errText="Please enter specialization areas"
          defaultValue={specialist?.profile?.specializationAreaDescription || ""}
          placeholder="Describe the types of clients and issues you specialize in, such as trauma recovery, emotional expression, anxiety, etc"
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          label="Specialization Areas *"
        />
      </Grid>

      <Typography
        color="#7A8A9E"
        fontWeight="500"
        fontStyle="italic"
      >Use the power of art to support clients' mental health. Detail your art therapy techniques and programs
      </Typography>
    </Fragment>
  )
}

export default ArtTherapist